<app-pagetitle title="{{ nameModal }}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
<div class="row">
    <div class="col-sm-12">
        <div class="card card-border">
            <div class="card-header">
                <div class="row" *hasDenied="{ nivel: idSprNivel, app: constant.PROCESOS }">
                    <div class="col-sm-6 text-sm-right">
                        <button *hasPermission="{app: constant.PROCESOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModal()">
                            <i class="fas fa-plus fa-lg mr-1"></i>Nuevo</button>
                    </div>
                </div>
            </div>

            <div class="container card-body table-responsive">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped table-bordered row-border hover">
                    <thead>
                        <tr>
                            <th>Nro.</th>
                            <th>Nombre</th>
                            <th>Fecha inicio</th>
                            <th>Estado</th>
                            <th>Importancia/Desempeño</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let proceso of dataObjetivoProceso; let indice = index">
                            <td>{{ indice + 1 }}</td>
                            <td>{{ proceso.nombre }}</td>
                            <td>{{ proceso.fechaInicio | date : "dd-MM-yyyy" }}</td>
                            <td>{{ proceso.estado == "1" ? "Activo" : "Inactivo" }}</td>
                            <td class="text-center">
                                <div class="row">
                                    <button type="button" tooltip="Editar"
                                        class="btn btn-sm btn-link waves-effect rounded-pill col px-0"
                                        title="Agregar desempeño de proceso" (click)="desempenioInit(proceso)">
                                        <i class="fas fa-tasks fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                            <td class="text-center">
                                <div class="row" *hasDenied="{ nivel: idSprNivel, app: constant.PROCESOS }">
                                    <button *hasPermission="{app: constant.PROCESOS,permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill col px-0" title="Editar este registro" (click)="update(proceso)">
                                        <i class="fas fa-pencil-alt fa-lg"></i>
                                    </button>
                                    <button *hasPermission="{app: constant.PROCESOS,permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect col px-0" title="Eliminar este registro" (click)="delete(proceso.idSprProceso)">
                                        <i class="fas fa-trash-alt fa-lg"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- MODAL PARA LA CONFIRMACION DEL BORRADO -->
<jw-modal id="delete" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>
<!-- MODAL PARA CREAR Y EDITAR -->

<jw-modal id="{{ nameModal }}" #modalChild>
    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 6%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{ nameModal }}</h3>
                <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
            </div>

            <div class="modal-body px-4">
                <form class="needs-validation" novalidate id="formProceso" [formGroup]="formProceso">
                    <input type="hidden" id="idSprProceso" formControlName="idSprProceso" />
                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="nombre" class="form-control-label text-md-right pt-1"><b>Unidad:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <input class="form-control" style="background-color: #f5f4f4" autocomplete="off" readonly="readonly" required="true" value="{{nombreUnidad}}" />
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprObjetivo" class="col-form-label text-md-right"><b>Objetivo:</b>
                            </label>
                        </div>
                        <div class="col-12 col-md-10">
                            <select id="idSprObjetivo" class="form-select form-control-sm" formControlName="idSprObjetivo" required="true" (change)="onChangeObjetivo($event)" [ngClass]="{ 'is-invalid': this.formProceso.get('idSprObjetivo')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('idSprObjetivo')?.errors,}">
                                <option *ngFor="let catObjetivoPlan of dataObjetivo" [ngValue]="catObjetivoPlan.idSprObjetivo" value="{{ catObjetivoPlan.idSprObjetivo }}">{{ catObjetivoPlan.nombre }}
                                </option>
                            </select>
                            <small class="invalid-feedback" *ngIf="this.formProceso.get('idSprObjetivo')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="nombre" class="form-control-label text-md-right"><b>Nombre:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea id="nombre" type="text" maxlength="500" class="form-control" required="true" rows="2" cols="30" placeholder="Nombre" formControlName="nombre" [ngClass]="{'is-invalid': this.formProceso.get('nombre')?.errors  && this.formSubmitted,  'is-valid': !this.formProceso.get('nombre')?.errors,  }">
                            </textarea>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('nombre')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="descripcion" class="col-form-label text-md-right"><b>Descripción:</b>
                            </label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea type="text" class="form-control" maxlength="3000" [(ngModel)]="textoAreaValue" placeholder="Descripción" (keyup)="onKey($event)" rows="3" cols="30" id                     formControlName="descripcion" [ngClass]="{'is-invalid':this.formProceso.get('descripcion')?.errors && this.formSubmitted,'is-valid': this.formProceso.value.descripcion}">
                            </textarea>
                            <div id="contador">{{ contador }} caracteres restantes</div>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('descripcion')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="disparador" class="form-control-label text-md-right pt-1"><b>Disparador:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea type="text" class="form-control" maxlength="500" [(ngModel)]="textoAreaValue1" placeholder="Disparador" (keyup)="onKey1($event)" rows="2" cols="30" id="descripcion"
                                formControlName="disparador" [ngClass]="{'is-invalid':this.formProceso.get('disparador')?.errors && this.formSubmitted,'is-valid': this.formProceso.value.disparador}">
                            </textarea>
                            <div id="contador1">{{ contador1 }} caracteres restantes</div>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('disparador')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="producto" class="form-control-label text-md-right pt-1"><b>Produto/Servicio:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <textarea class="form-control" id="producto" maxlength="500" placeholder="Producto" formControlName="producto" [ngClass]="{'is-invalid':this.formProceso.get('producto')?.errors && this.formSubmitted,'is-valid': this.formProceso.value.producto}">
                            </textarea>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('producto')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprEquipoGerencial" class="form-control-label text-md-right pt-1"><b>Responsable:</b></label>
                        </div>
                        <div class="col-12 col-md-10">
                            <select class="form-select col-9" id="idSprEquipoGerencial" formControlName="idSprEquipoGerencial" required="true" [ngClass]="{'is-invalid': this.formProceso.get('idSprEquipoGerencial')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('idSprEquipoGerencial')?.errors,}">
                                <option *ngFor="let row of dataParticipantesElemento" value="{{ row.idSprEquipoGerencial }}">
                                    {{ row.gradoNombres }}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('idSprEquipoGerencial')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprTipoProceso" class="form-control-label text-md-right pt-1"><b>Tipo de proceso:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-12" id="idSprTipoProceso" formControlName="idSprTipoProceso" required="true" [ngClass]="{'is-invalid': this.formProceso.get('idSprTipoProceso')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('idSprTipoProceso')?.errors,}">
                                <option *ngFor="let tipo of dataTipoProceso" value="{{ tipo.idSprEspecialUno }}">
                                    {{ tipo.nombre }}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('idSprTipoProceso')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>

                        <div class="col col-md-2 text-md-right">
                            <label for="idSprTipoCliente" class="form-control-label text-md-right pt-1"><b>Tipo de cliente:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-9" formControlName="idSprTipoCliente" required="true" [ngClass]="{'is-invalid': this.formProceso.get('idSprTipoCliente')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('idSprTipoCliente')?.errors,}">
                                <option *ngFor="let catCliente of dataCatComun" value="{{ catCliente.idSprComun }}">
                                    {{ catCliente.nombre }}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formProceso.get('idSprTipoCliente')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="fechaInicio" class="form-control-label text-md-right pt-1"><b>Fecha inicio:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input type="date" class="form-control" required="true" placeholder="fechaInicio" formControlName="fechaInicio" [ngClass]="{'is-invalid': this.formProceso.get('fechaInicio')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('fechaInicio')?.errors,}"
                                date />
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formProceso.get('fechaInicio')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
                                <div class="col text-danger">
                                    <span class="font-italic" *ngIf="this.formProceso.get('fechaInicio').errors?.fechaInicio">La fecha debe estar comprendida entre{{this.formProceso.get("fechaInicio")?.errors.fechaInicio}}y{{this.formProceso.get("fechaInicio")?.errors.fechaFin }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="col col-md-2 text-md-right">
                            <label for="fechaFin" class="form-control-label text-md-right pt-1"><b>Fecha fin:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input type="date" class="form-control" required="true" placeholder="fechaFin" formControlName="fechaFin" [ngClass]="{'is-invalid': this.formProceso.get('fechaFin')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('fechaFin')?.errors,}"
                                date />
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formProceso.get('fechaFin')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
                                <span class="font-italic" *ngIf="this.formProceso.get('fechaFin').errors?.fechaInicio">La fecha debe estar comprendida entre{{ this.formProceso.get("fechaFin")?.errors.fechaInicio }} y
                                    {{ this.formProceso.get("fechaFin")?.errors.fechaFin }}
                                </span>
                            </div>
                        </div>
                        <div class="col-12 col-md-12">
                            <div class="col text-danger">
                                <span *ngIf="this.formProceso?.errors">
                                    {{ formProceso.errors.mensaje }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-md-right">
                            <label for="tiempoCiclo" class="form-control-label text-md-right pt-1"><b>Tiempo ciclo:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input type="number" maxlength="50" min="0" max="100" class="form-control" style="text-transform: uppercase" required="true" placeholder="tiempo de ciclo" onkeypress="return (event.charCode>= 48 && event.charCode <= 57)" formControlName="tiempoCiclo" [ngClass]="{'is-invalid':this.formProceso.get('tiempoCiclo')?.errors &&this.formSubmitted,'is-valid': this.formProceso.value.tiempoCiclo }" />
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formProceso.get('tiempoCiclo')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
                            </div>
                        </div>

                        <div class="col col-md-2 text-md-right">
                            <label for="numeroPersonaAsignada" class="form-control-label text-md-right pt-1"><b>Nro. personas asignadas:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <input type="number" maxlength="50" min="0" max="100" class="form-control" style="text-transform: uppercase" required="true" placeholder="N° personas" onkeypress="return (event.charCode>= 48 && event.charCode <= 57)" formControlName="numeroPersonaAsignada" [ngClass]="{'is-invalid':this.formProceso.get('numeroPersonaAsignada')?.errors && this.formSubmitted,'is-valid': this.formProceso.value.numeroPersonaAsignada}" />
                            <div class="col text-danger">
                                <small class="font-italic" *ngIf="this.formProceso.get('numeroPersonaAsignada')?.errors?.['required'] && this.formSubmitted">Campo requerido</small>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-xl-right">
                            <label for="procesoDocumentado" class="form-control-label text-md-right pt-1"><b>Proceso documentado:</b></label>
                        </div>

                        <div class="col-12 col-md-4">
                            <select id="procesoDocumentado" class="form-select" formControlName="procesoDocumentado" required [ngClass]="{'is-invalid': this.formProceso.get('procesoDocumentado')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('procesoDocumentado')?.errors,}">
                                <option [value]="item.value" *ngFor="let item of selectItems1">
                                    {{ item.label }}
                                </option>
                            </select>
                            <small class="invalid-feedback" *ngIf="formSubmitted && procesoForm['procesoDocumentado'].errors">Campo requerido.</small>
                        </div>
                        <div class="col col-md-2 text-md-right">
                            <label for="idSprMejoras"class="form-control-label text-md-right pt-1"><b>Mejoras:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select class="form-select col-12" id="idSprMejoras" formControlName="idSprMejoras" required="true" [ngClass]="{'is-invalid': this.formProceso.get('idSprMejoras')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('idSprMejoras')?.errors,}">
                                <option *ngFor="let tipoMejoras of dataMejoras" value="{{ tipoMejoras.idSprComun }}">
                                    {{ tipoMejoras.nombre }}
                                </option>
                            </select>
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formProceso.get('idSprMejoras')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-xl-right">
                            <label for="procesoCertificado" class="form-control-label text-md-right pt-1"><b>Proceso certificado:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select id="procesoCertificado" class="form-select" formControlName="procesoCertificado" required (ngModelChange)="openFechaCertificacion($event)" [ngClass]="{'is-invalid': this.formProceso.get('procesoCertificado')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('procesoCertificado')?.errors,}">
                                <option [value]="item.value" *ngFor="let item of selectItems2">
                                    {{ item.label }}
                                </option>
                            </select>
                            <small class="invalid-feedback" *ngIf="formSubmitted && procesoForm['procesoCertificado'].errors">Campo requerido.</small>
                        </div>


                        <div *ngIf="openFechaCertifi== true" class="col col-md-2 text-md-right">
                            <label for="fechaCertificacion" class="form-control-label text-md-right pt-1"><b>Fecha certificación:</b></label>
                        </div>
                        <div *ngIf="openFechaCertifi== true" class="col-12 col-md-4">
                            <input type="date" class="form-control" required="true" placeholder="fechaCertificacion" formControlName="fechaCertificacion" [ngClass]="{'is-invalid': this.formProceso.get('fechaCertificacion')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('fechaCertificacion')?.errors,}" date />
                            <div class="col text-danger">
                                <span class="font-italic" *ngIf="this.formProceso.get('fechaCertificacion')?.errors?.['required'] && this.formSubmitted">Campo requerido</span>
                                <span class="font-italic" *ngIf="this.formProceso.get('fechaCertificacion').errors?.fechaInicio">La fecha debe estar comprendida entre{{this.formProceso.get("fechaCertificacion")?.errors.fechaInicio}}y{{this.formProceso.get("fechaCertificacion")?.errors.fechaFin}}
                                </span>
                            </div>
                        </div>

                        <div *ngIf="openFechaCertifi== false" class="col col-md-2 text-md-right">
                            <label for="fechaCertificacion" class="form-control-label text-md-right pt-1"><b>Fecha certificación:</b></label>
                        </div>
                        <div *ngIf="openFechaCertifi== false" class="col-12 col-md-4">
                            <input type="date" class="form-control" required="false" formControlName="fechaCertificacion" readonly="true" style="background-color: #e9e8e8" date />
                        </div>
                    </div>

                    <div class="form-group row mb-2">
                        <div class="col col-md-2 text-xl-right">
                            <label for="estado" class="form-control-label text-md-right pt-1"><b>Estado:</b></label>
                        </div>
                        <div class="col-12 col-md-4">
                            <select id="estado" class="form-select" formControlName="estado" required [ngClass]="{'is-invalid': this.formProceso.get('estado')?.errors && this.formSubmitted,'is-valid': !this.formProceso.get('estado')?.errors,}">
                                <option [value]="item.value" *ngFor="let item of selectItems">
                                    {{ item.label }}
                                </option>
                            </select>
                            <small class="invalid-feedback" *ngIf="formSubmitted && procesoForm['estado'].errors">Campo requerido.</small>
                        </div>
                    </div>

                    <div class="form-group row mb-2 ">
                        <div class="col col-md-2 text-md-right ">
                            <label for="ares" class="col-form-label text-md-right "><b>Areas:</b></label>
                        </div>
                        <div class="col-12 col-md-10 ">
                            <div *ngFor="let row of dataAreas; let indice = index" class="form-check">
                                <input [checked]="row.checked" type="checkbox" class="form-check-input" id="flexCheckDefault{{indice}}" (change)="onChange($event,row.idSprArea)"
                                    name="{{row.idSprArea}} " value={{row.idSprArea}}>
                                <a><label for={{row.idSprArea}} class="form-check-label">
                                        {{row.nombre}}
                                    </label></a>
                                <div class="col text-danger">
                                    <span class="font-italic" *ngIf="this.formProceso.get('')?.errors?.[ 'required'] && this.formSubmitted">Campo requerido</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary waves-effect" (click)="closeModal()">Cerrar</button>
                <button type="button" class="btn btn-info" (click)="onSubmit()">Guardar</button>
            </div>
        </div>
    </div>
</jw-modal>

<!-- Inicio modal detalle proyeto -->
<jw-modal id="{{ modalDesempenioProceso }}">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top: 5%; max-width: 75%; max-height: 90%">
        <div class="modal-content">
            <div class="modal-header pb-3">
                <h3 class="modal-title">{{ tituloModal }}</h3>
                <button type="button" class="btn-close" (click)="closeModalDesempenio()" aria-label="Close"></button>
            </div>
            <div class="modal-body px-5">
                <div class="card-header">
                    <div class="form-group row mb-2">
                        <div class="col col-md-12">
                            <span><b>Procesos: </b>{{ desripcionProceso }}</span>
                        </div>
                    </div>
                </div>
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="hito" role="tabpanel" aria-labelledby="hito-tab">
                        <app-desempenio-proceso [init]="desempenio"></app-desempenio-proceso>
                    </div>
                </div>
            </div>
        </div>
    </div>
</jw-modal>